import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { GoogleMap } from "@angular/google-maps";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOMenuItem } from "src/app/shared/models/oo-menu-item";
import { OOOrderType } from "src/app/shared/models/oo-order-type";
import { OOOrderTypeDeliveryZone } from "src/app/shared/models/oo-order-type-delivery-zone";

// declare const google: any;

@Component({
	selector: "app-order-type-zones",
	templateUrl: "./order-type-zones.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class OrderTypeZonesComponent implements OnInit {
	@ViewChild(GoogleMap, { static: false }) set map(m: GoogleMap) {
		if (m) {
			this.mapLoaded = true;
			this.initDrawingManager(m);
			this.setCenter();
		}
	}
	@Output() deliveryZoneEmitter: EventEmitter<OOOrderTypeDeliveryZone[]> = new EventEmitter<OOOrderTypeDeliveryZone[]>();

	@Input() orderType: OOOrderType;
	@Output() orderTypeChange = new EventEmitter<OOOrderType>();

	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	center: google.maps.LatLngLiteral;
	// deliveryZoneList: OOOrderTypeDeliveryZone[] = [];
	drawing: any[] = [];
	drawingManager: any;
	loaded: boolean = false;
	markerOptions: google.maps.MarkerOptions = { draggable: false };
	mapLoaded: boolean = false;
	menuItemList: OOMenuItem[];
	options: google.maps.MapOptions = {
		mapTypeId: "hybrid",
		zoomControl: true,
		scrollwheel: true,
		disableDoubleClickZoom: true,
		maxZoom: 20,
		minZoom: 10,
	};
	polyComplete: boolean = false;
	polyOptions = {
		strokeColor: "#199c42",
		fillColor: "#91fab2",
	};
	selectedArea = 0;
	unsaved: boolean = false;
	zoom = 15;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {
		if (!this.orderType.OOOrderTypeDeliveryZone) {
			this.orderType.OOOrderTypeDeliveryZone = [];
		} else {
			this.orderType.OOOrderTypeDeliveryZone = this.orderType.OOOrderTypeDeliveryZone.map((i) => {
				return new OOOrderTypeDeliveryZone(i);
			});
		}

		this.loaded = true;
	}

	deleteZone(zone: OOOrderTypeDeliveryZone) {
		this.focuslink.orderTypeZoneDelete(this.venueSvc.venueKey, this.orderType.key, zone.key);
		this.orderType.OOOrderTypeDeliveryZone.splice(
			this.orderType.OOOrderTypeDeliveryZone.findIndex((dz) => dz.key === zone.key),
			1
		);
	}

	async setCenter() {
		this.center = {
			lat: +this.venueSvc.ooVenue.latitude,
			lng: +this.venueSvc.ooVenue.longitude,
		};
	}

	initDrawingManager = (map: any) => {
		const self = this;
		const randomColor = this.app.references.randomStrokeFillGenerator();
		this.polyOptions.fillColor = randomColor.fill;
		this.polyOptions.strokeColor = randomColor.stroke;
		const drawingOptions = {
			drawingMode: google.maps.drawing.OverlayType.POLYGON,
			drawingControl: true,
			drawingControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER,
				drawingModes: [google.maps.drawing.OverlayType.POLYGON],
			},
			polygonOptions: {
				strokeColor: this.polyOptions.strokeColor,
				fillColor: this.polyOptions.fillColor,
			},
		};
		this.drawingManager = new google.maps.drawing.DrawingManager(drawingOptions);
		this.drawingManager.setMap(map.googleMap);

		google.maps.event.addListener(this.drawingManager, "overlaycomplete", (event) => {
			console.log(event);
			console.log("Drawing complete");
			this.drawing.push(event);
			if (event.type === google.maps.drawing.OverlayType.POLYGON) {
				console.log("event type = polygon");
				const paths = event.overlay.getPaths();
				console.log(paths);
				for (let p = 0; p < paths.getLength(); p++) {
					google.maps.event.addListener(paths.getAt(p), "set_at", () => {
						if (!event.overlay.drag) {
							self.updatePointList(event.overlay.getPath(), drawingOptions.polygonOptions, event);
						}
					});
					google.maps.event.addListener(paths.getAt(p), "insert_at", () => {
						self.updatePointList(event.overlay.getPath(), drawingOptions.polygonOptions, event);
					});
					google.maps.event.addListener(paths.getAt(p), "remove_at", () => {
						self.updatePointList(event.overlay.getPath(), drawingOptions.polygonOptions, event);
					});
				}
				self.updatePointList(event.overlay.getPath(), drawingOptions.polygonOptions, event);
			}
			if (event.type !== google.maps.drawing.OverlayType.MARKER) {
				// Switch back to non-drawing mode after drawing a shape.
				self.drawingManager.setDrawingMode(null);
				// To hide:
				self.drawingManager.setOptions({
					drawingControl: false,
				});
			}

			for (let d of this.drawing) {
				d.overlay.setMap(null);
			}
			this.initDrawingManager(map);
		});
	};

	updatePointList(path, options, event) {
		const points = [];
		const len = path.getLength();
		for (let i = 0; i < len; i++) {
			points.push(path.getAt(i).toJSON());
		}
		// this.selectedArea = google.maps.geometry.spherical.computeArea(path);
		this.orderType.OOOrderTypeDeliveryZone.push(
			new OOOrderTypeDeliveryZone({
				venueKey: this.venueSvc.venueKey,
				orderTypeKey: this.orderType.key,
				points: points,
				vertices: JSON.stringify(points),
				strokeColor: options.strokeColor,
				fillColor: options.fillColor,
				polygonOptions: options,
			})
		);
	}

	async saveZones() {
		await this.focuslink.orderTypeZonePost(this.venueSvc.venueKey, this.orderType.key, this.orderType.OOOrderTypeDeliveryZone);
		//this.deliveryZoneEmitter.emit(this.deliveryZoneList);
		this.app.msgSvc.add({ severity: "success", summary: "Zones saved" });
	}
}
